import React from "react";
import { Flex, LoadingIndicator, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { detailscontainer, detailsBox } from "./styles_vanilla.css";

const RemediationCompletionScreen = ({
  investingAccount,
  informationProvidedBy,
  submittingResponse,
  date,
  gpName,
}: {
  investingAccount?: string | null;
  informationProvidedBy?: string | null;
  submittingResponse: boolean;
  date?: string | null;
  gpName?: string | null;
}) => {
  if (submittingResponse) {
    return <LoadingIndicator />;
  }
  return (
    <div>
      <Flex gap={Sizes.LG} alignItems="center">
        <Icon type="check-circle" size="xxx-large" color={Colors.Success400} variant="solid" />
        <Flex flexDirection="column" gap="2px">
          <Text variant="h2">Thank you for providing additional information</Text>
          <Text variant="secondary-md">
            {gpName ?? "the manager"} will reach out if there are any additional questions
          </Text>
        </Flex>
      </Flex>
      <Flex gap={Sizes.XS} flexDirection="column" className={detailscontainer}>
        <Flex justifyContent="space-between" alignItems="center" className={detailsBox}>
          <Text variant="secondary-md">Investing account</Text>
          <Text variant="secondary-md">{investingAccount ?? "the investing account"}</Text>
        </Flex>
        <Flex justifyContent="space-between" alignItems="center" className={detailsBox}>
          <Text variant="secondary-md">Information provided by</Text>
          <Text variant="secondary-md">{informationProvidedBy ?? "N/A"}</Text>
        </Flex>
        <Flex justifyContent="space-between" alignItems="center" className={detailsBox}>
          <Text variant="secondary-md">Date</Text>
          <Text variant="secondary-md">{date ?? "N/A"}</Text>
        </Flex>
      </Flex>
    </div>
  );
};

export default RemediationCompletionScreen;
